
import axios from 'utils/axios';
import {dispatch, store} from 'store';

import {createSlice} from '@reduxjs/toolkit';
import {NoticeboardProps} from "types/props-obj/NoticeboardProps";

const initialState: NoticeboardProps = {
    apiEndPoint: "noticeboard",
    pageLimit: 5,
    pageNumber: 1,
    isOpen: false,
    list: [],
    item: null,
    error: null,
    alertPopup: false
};

const noticeboard = createSlice({
    name: initialState.apiEndPoint,
    initialState,
    reducers: {
        hasError(state, action) {
            state.error = action.payload.error;
        },
        setPageNumber(state, action) {
            state.pageNumber = action.payload;
        },
        setPageLimit(state, action) {
            state.pageLimit = action.payload;
        },
        // get all Item list
        getList(state, action) {
            state.list.push(action.payload);
            state.list = state.list.filter((liste) => liste.id !== 0);
            state.isLoading=false;
        },
        alertPopupToggle(state, action) {
            state.alertPopup = action.payload.alertPopup;
        },
        openToggle(state, action) {
            state.isOpen = action.payload.isOpen;
        },
        // get Item details
        setItem(state, action) {
            state.item = action.payload;
            state.isLoading=false;
        },

        // GET Items
        setItemsSuccess(state, action) {
            state.list = action.payload.data;
            state.current_page=action.payload.current_page;
            state.last_page=action.payload.last_page;
            state.total=action.payload.total;
            state.isLoading=false;
        },

        // ADD Item
        addItemSuccess(state, action) {
            state.list = [...state.list,action.payload];
            state.isLoading=false;
        },

        // EDIT Item
        editItemSuccess(state, action) {
            var foundIndex = state.list.findIndex(x => x.id === action.payload.id);
            state.item=action.payload;
            state.list[foundIndex] = action.payload;
            state.isLoading=false;
        },

        deleteItemSuccess(state, action) {
            state.list = state.list.filter((item) => item.id !== action.payload);
        },



        setApiEndPoint(state, action) {
            state.apiEndPoint = action.payload;
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        },

    }
});


export default noticeboard.reducer;

function getApiEndPoint(){
    return store.getState().noticeboard.apiEndPoint
}

export const { alertPopupToggle,openToggle,setPageNumber,setLoading,setPageLimit,setApiEndPoint } = noticeboard.actions;
export function getList(params:any={}) {
    return async () => {
        dispatch(noticeboard.actions.setLoading(true));
        try {
            const response = await axios.get(getApiEndPoint(),{params:params});
            dispatch(noticeboard.actions.setItemsSuccess(response.data));
        } catch (error) {
            dispatch(noticeboard.actions.hasError(error));
        }
    };
}

export function getItem(id: number | undefined) {
    return async () => {
        dispatch(noticeboard.actions.setLoading(true));

        try {
            const response = await axios.get([getApiEndPoint(),  id].join('/'));
            dispatch(noticeboard.actions.setItem(response.data));
        } catch (error) {
            dispatch(noticeboard.actions.hasError(error));
            dispatch(noticeboard.actions.setLoading(false));
        }
    };
}

export function addItem(ls:any) {
    return async () => {
        dispatch(noticeboard.actions.setLoading(true));
        try {
            const response = await axios.post(getApiEndPoint(), ls,{headers:{'Content-Type': 'multipart/form-data'}});
            dispatch(noticeboard.actions.addItemSuccess(response.data));
        } catch (error) {
            dispatch(noticeboard.actions.hasError(error));
            dispatch(noticeboard.actions.setLoading(false));
        }
    };
}

export function editItem(id: number | undefined,ls: any) {
    return async () => {
        dispatch(noticeboard.actions.setLoading(true));
        try {
            const response = await axios.put([getApiEndPoint(),  id].join('/'), ls);
            dispatch(noticeboard.actions.editItemSuccess(response.data));
        } catch (error) {
            dispatch(noticeboard.actions.hasError(error));
            dispatch(noticeboard.actions.setLoading(false));
        }
    };
}

export function deleteItem(id: number | undefined) {
    return async () => {
        try {
            await axios.delete([getApiEndPoint(),  id].join('/'));
            dispatch(noticeboard.actions.deleteItemSuccess(id));
        } catch (error) {
            dispatch(noticeboard.actions.hasError(error));
        }
    };
}